import type {PageRouteConfig} from '@router';

import VendorRegister from 'modules/VendorRegister/VendorRegister';

export function createVendorRegisterRoute(): PageRouteConfig {
  return {
    element: <VendorRegister />,
    layout: {
      title: 'ثبت نام فروشگاه',
      hasNavigate: false,
      hasHeader: true,
      hasBack: false,
      hasLeftIcon: false
    }
  };
}
